import React from 'react';
import './App.css';
import Game from "./components/Game";

function App() {
  return (
    <div className="App">
        <Game/>
    </div>
  );
}

export default App;
